import React from 'react';
import Wizard from '../../../Modules/Wizard/Componets/Wizard';

interface Props {
	onSuccess: () => void;
	patientId: string;
	caseId?: string;
}

const MedicalReportSlovakia: React.FC<Props> = ({
	onSuccess,
	patientId,
	caseId,
}) => {
	return (
		<Wizard
			wizardKey='medical-report'
			onWizardDone={onSuccess}
			initialData={{ patientId, caseId }}
			keepInitialData
			jobWaitingSetup={{
				waitingMessage: 'component.jobWaiting.waitingGenerateMedicalReport',
				failedMessage: 'component.jobWaiting.jobFailedGenerateMedicalReport',
				timeout: 180000,
			}}
		/>
	);
};

export default MedicalReportSlovakia;
